module.exports = __webpack_public_path__ + "static/media/develop1.e81c7a0d.png";